<template>
<div class="page fms">
  <h1>FMS</h1>
</div>
</template>

<script>
export default {
name: "Fms"
}
</script>
